import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "#Geeksonwater",
  "description": "",
  "published": "2011-09-24T00:00:00.000Z",
  "redirect_from": ["/blog/geeksonwater/swizec/2503"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Friday marked the first annual (hopefully) geeks on water event.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/990b0015ab38406f950e2ce58f90f3af_74.jpg",
        "alt": null,
        "title": "Geeks on water ... almost"
      }}></img></p>
    <p>{`A whole bunch of geeks and geekettes from `}<a parentName="p" {...{
        "href": "http://hekovnik.si/"
      }}>{`Hekovnik`}</a>{` got together to go `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Kayaking",
        "title": "Kayaking"
      }}>{`kayaking`}</a>{` on the river Krka. Most of us for the first time. We have `}<a parentName="p" {...{
        "href": "https://twitter.com/#!/refaktor"
      }}>{`@refaktor `}</a>{`to thank for herding us all together and making it happen. Without him we'd probably still be trying to figure out if everyone has the time this year or would 2012 suit us better.`}</p>
    <p>{`Herding geeks is like herding cats :P`}</p>
    <p>{`I for one have to say I had a blast and I think everyone else had a blast as well.`}</p>
    <p>{`The fun part was how we were put in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Wetsuit",
        "title": "Wetsuit"
      }}>{`wetsuits`}</a>{`, given a paddle and a kayak and some basic instructions that the paddles are to be held by the handle and that they are used to both propel the boat forward and to steer it. And off we were for the first 800 meters.`}</p>
    <p>{`Those things are impossible to steer! The kayak's have a mind of their own and wherever they want to go they will go ... until someone tells you that you're supposed to `}<em parentName="p">{`feel`}</em>{` the kayak. Anticipate its next move and act accordingly. Then, suddenly, you can go in an almost straight line! Quickly even!`}</p>
    <p>{`Of course they only tell you this at an opportune spot 800 meters down the river ...`}</p>
    <p>{`Jumping over the dams was pretty fun too. The water was pretty low and our skills weren't all that ... existant ... so we basically ran aground on top of every jump then got pushed off by the instructor. Most jumps went awesomely, but on one particular jump I could swear the instructor was throwing us over like potatoes! We were faceplanting into the water like a bunch of bosses!`}</p>
    <p>{`But even falling out was fun!`}</p>
    <p>{`The whole trip was packed with fun and I suggest everyone who likes getting wet, and who doesn't?, to give kayaking a try. It's simply awesome fun! Can't say I'd survive going down a river alone in a kayak now, but at lest I can sort of go in a straight line.`}</p>
    <p>{`Shame there's no pics of geeks `}<em parentName="p">{`on`}</em>{` the water - stupid water hating electronics.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://itssamuraijosh.wordpress.com/2011/09/22/the-difference-between-geeks-nerds/"
        }}>{`The Difference Between Geeks & Nerds`}</a>{` (itssamuraijosh.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://carolinebeavon.com/2011/09/24/this-geeks-off-to-paris-and-needs-suggestions/"
        }}>{`This geek's off to Paris and needs suggestions`}</a>{` (carolinebeavon.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dailypicksandflicks.com/2011/09/24/kayaker-jesse-coombs-plunges-down-96ft-waterfall-video/"
        }}>{`Kayaker Jesse Coombs Plunges Down 96ft Waterfall (Video)`}</a>{` (dailypicksandflicks.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=bb4ed28f-ae7d-4b29-b7f4-d31fd23f977e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      